module.exports = __webpack_public_path__ + "img/azn-white.fff246ef.svg";